function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import Provider from "./BaseProvider";
import each from "lodash/forEach";
import pick from "lodash/pick";
import omit from "lodash/omit";
import keys from "lodash/keys";
import options from "../../apiV2/ProviderOptions";
// This is the provider for loading + storing MY data per chart.
var SocialChartProvider = /*#__PURE__*/ function(Provider) {
    "use strict";
    _inherits(SocialChartProvider, Provider);
    var _super = _createSuper(SocialChartProvider);
    function SocialChartProvider() {
        _classCallCheck(this, SocialChartProvider);
        var _this;
        _this = _super.call(this);
        _defineProperty(_assertThisInitialized(_this), "_endpointComm", function(data) {
            console.warn("SocialChartProvider:_setData - No Endpoints Set, overwrite this Function with the setDataEndpoints(getter, setter) Function.");
            return {
                socialChart: {
                    getter: function() {
                        return {
                            then: function(cb) {
                                cb(_this._chartData);
                                return {
                                    catch: function() {}
                                };
                            }
                        };
                    },
                    setter: function(d) {
                        _this._chartData = {
                            data: d,
                            user: {
                                name: "Mustermann",
                                id: 1,
                                is_active: true
                            }
                        };
                        return {
                            then: function(cb) {
                                cb(_this._chartData);
                                return {
                                    catch: function() {}
                                };
                            }
                        };
                    }
                },
                communityChart: {
                    getter: function() {
                        console.log("community Chart Getter");
                        return {
                            then: function(fn) {
                                fn([
                                    _this._chartData,
                                    _this._chartData
                                ]);
                                return {
                                    catch: function() {}
                                };
                            }
                        };
                    }
                }
            };
        });
        // Filter self and remove userdata -> We are returning anonymus data
        _defineProperty(_assertThisInitialized(_this), "_structOutput", function(channel, data) {
            var user = _this._getUser() || {};
            var _data = [];
            switch(channel){
                case "communityChart":
                case "evalCommunity":
                    each(data, function(d) {
                        var myself = d.user && user && d.user.id === user.id;
                        d.user = pick(d.user, [
                            "is_active"
                        ]);
                        if (!myself || channel === "evalCommunity") {
                            _data.push(_this.DataStruct(d, false));
                        }
                    });
                    return _data;
                case "communityUser":
                    // For now dont return data, unitl we know how to deal with privacy & security
                    _data = data.slice();
                    _data = _data.filter(function(u) {
                        return u.id !== user.id;
                    });
                    return [];
                default:
                    return _this.DataStruct(data, false);
            }
        });
        _defineProperty(_assertThisInitialized(_this), "DataStruct", function(rawData, omitUser) {
            // exclude this Propertys from Meta
            var excludeProps = [
                "data",
                "id",
                "node_id"
            ];
            if (omitUser) {
                excludeProps.push("user");
            }
            return {
                meta: omit(rawData, excludeProps),
                data: rawData ? rawData.data : null
            };
        });
        _this._chartData = {
            data: {},
            user: {
                name: "Mustermann",
                id: 1,
                is_active: true
            },
            id: 1
        };
        _this._hasEndpoint = false;
        return _this;
    }
    _createClass(SocialChartProvider, [
        {
            // When there is a new listener subscribed
            key: "onSubscribed",
            value: function onSubscribed(uid, channel) {
                var _this = this;
                // Initialization Message
                this.publish(uid, channel, "meta", {
                    willPersist: this._hasEndpoint
                });
                // TODO? (RG, AR) Wenn eine Extension im :meta daten initial setzt, dann erhält diese
                //       Extensions zwei mal ein save (einmal getriggered von onMessageReceived:save->:changed)
                //       und zweitens, die nachfolgende Zeile: ->changed.
                var ep = this._endpointComm()[channel === "evalCommunity" ? "communityChart" : channel];
                console.log("onSubscribe", ep, channel);
                if (ep) {
                    ep.getter(options(uid)).then(function(d) {
                        _this.publish(uid, channel, "changed", _this._structOutput(channel, d));
                    }).catch(function(err) {
                        _this.publish(uid, channel, "error", err);
                    });
                } else {
                    this.publish(uid, channel, "error", "Endpoint isn't set jet");
                }
            }
        },
        {
            // When an extension sends data
            key: "onMessageReceived",
            value: function onMessageReceived(uid, channel, msgId, data) {
                var _this = this;
                var channelEndpoint = this._endpointComm()[channel === "evalCommunity" ? "communityChart" : channel];
                switch(msgId){
                    case "save":
                        if (channelEndpoint && channelEndpoint.setter) {
                            channelEndpoint.setter(data, options(uid)).then(function(d) {
                                _this.publish(uid, channel, "changed", _this._structOutput(channel, d));
                            }).catch(function(err) {
                                _this.publish(uid, channel, "error", err);
                            });
                        } else {
                            this.publish(uid, channel, "error", "You can't write to this channel");
                        }
                        break;
                    case "get":
                        console.log("omr GET", channelEndpoint);
                        if (channelEndpoint && channelEndpoint.getter) {
                            channelEndpoint.getter(options(uid)).then(function(d) {
                                _this.publish(uid, channel, "changed", _this._structOutput(channel, d));
                            }).catch(function(err) {
                                if (err.status === 500 || err.code === 500) {
                                    _this.publish(uid, channel, "changed", _this._structOutput(channel, []));
                                }
                                _this.publish(uid, channel, "error", err);
                            });
                        } else {
                            this.publish(uid, channel, "error", "You can't read this channel");
                        }
                        break;
                    default:
                }
            }
        },
        {
            key: "setDataEndpoints",
            value: function setDataEndpoints(comm) {
                var _this = this;
                this._hasEndpoint = true;
                this._endpointComm = comm;
                keys(this._subscriptions).forEach(function(uid) {
                    _this._subscriptions.forEach(function(ch) {
                        _this.onMessageReceived(uid, ch, "get");
                    });
                });
            }
        },
        {
            key: "setUserGetter",
            value: function setUserGetter(getter) {
                this._getUser = getter;
            }
        },
        {
            key: "_getUser",
            value: function _getUser() {
                console.warn("SocialChartProvider:_getUser - No Getter set, overwrite this Function with the setUserGetter(getter) Function.");
                return {};
            }
        }
    ]);
    return SocialChartProvider;
}(Provider);
// channel socialChart => MY data
// communityChart      => everyone elses data
SocialChartProvider.providedChannels = [
    "socialChart",
    "communityChart",
    "evalCommunity"
];
var _SocialChartProvider = new SocialChartProvider();
export default _SocialChartProvider;
